/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Provider } from '../../types';

type Requestable = Provider | { request: (args: { method: string; params?: any[] | any }) => Promise<any> };

export async function requestChangeWalletChain(chain: Chain, externalProvider: Requestable): Promise<void> {
	try {
		await externalProvider.request({
			method: 'wallet_switchEthereumChain',
			params: [{ chainId: `0x${Number(chain.chainId).toString(16)}` }],
		});
	} catch (e: any) {
		//probably error.code === 4902
		if (e?.code === 4902 || (e.message && e.message.indexOf('wallet_addEthereumChain') > -1)) {
			await externalProvider.request({
				method: 'wallet_addEthereumChain',
				params: [
					{
						chainId: `0x${Number(chain.chainId).toString(16)}`,
						rpcUrls: [chain.rpcURL],
						chainName: chain.fullChainName,
						nativeCurrency: {
							name: chain.baseToken.name,
							symbol: chain.baseToken.symbol,
							decimals: chain.baseToken.decimals,
						},
						iconUrls: [chain.baseToken.logoURI],
						blockExplorerUrls: [chain.blockExplorer],
					},
				],
			});
		}
		throw e;
	}
}

export function findWallet(
	ethereum: any,
	inputCondition: 'isMetaMask' | 'isCoinbaseWallet',
	_callStack = 4,
): any | undefined {
	if (!ethereum) {
		return;
	}
	if (!ethereum?.detected?.length && !ethereum.providers?.length && ethereum[inputCondition]) {
		return ethereum;
	}
	if (!ethereum.detected?.length && ethereum.providers?.length) {
		const p = ethereum.providers.find((p: any) => !!p[inputCondition]);
		if (p) {
			return p;
		}
	}
	if (ethereum.detected?.length) {
		if (inputCondition === 'isMetaMask') {
			const p = ethereum.detected.find(
				(p: any) => !p?.detected?.length && !p?.providers?.length && p[inputCondition],
			);
			if (p) {
				return p;
			}
		} else if (inputCondition === 'isCoinbaseWallet') {
			const p = ethereum.detected.find((p: any) => !p?.detected?.length && p?.providerMap);

			if (p && p.providerMap && p.providerMap.get) {
				const coinbaseWallet = p.providerMap.get('CoinbaseWallet');
				if (coinbaseWallet) {
					return coinbaseWallet;
				}
			}
		}
	}
	return;
}